import i18n from "../../../../../i18n";
import { NoResults } from "../../../../../reports/shared/report-components";
import { SessionNoteRow, SessionNoteRowProps } from "../../session-notes/SessionNoteRow";
import { Thumbnail } from "../hooks/useThumbnails";
import { LiveProctoringSessionNote } from "../hooks/useVideoEvents";
import styles from "./LiveNotesPanel.module.css";

type LiveNotesPanelProps = {
	liveNotes: LiveProctoringSessionNote[];
	thumbnails: Thumbnail[];
} & Pick<SessionNoteRowProps<LiveProctoringSessionNote>, "dispatch" | "duration" | "offsetGetter">;

export default function LiveNotesPanel({
	liveNotes,
	dispatch,
	duration,
	offsetGetter: timeOffset,
	thumbnails,
}: LiveNotesPanelProps) {
	return (
		<div className={styles.liveNotesPanel}>
			<div className={styles.liveNotesContent}>
				{liveNotes.length === 0 ? (
					<NoResults text={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.noNotesAdded")} add={true} />
				) : (
					<div className={styles.liveBarContentNotes}>
						{liveNotes.map((v) => (
							<SessionNoteRow
								key={v.id}
								sessionNote={v}
								thumbnails={thumbnails}
								offsetGetter={timeOffset}
								dispatch={dispatch}
								duration={duration ?? 0}
							/>
						))}
					</div>
				)}
			</div>
		</div>
	);
}
